import { render, staticRenderFns } from "./HopPot.vue?vue&type=template&id=2bc5d0c8"
import script from "./HopPot.vue?vue&type=script&lang=js"
export * from "./HopPot.vue?vue&type=script&lang=js"
import style0 from "./HopPot.vue?vue&type=style&index=0&id=2bc5d0c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports